import type { TransactionPredicate } from './types';
import { getPartnerName } from '../fields/partner-name/getPartnerName';

export const hasAdjustedPartnerName: TransactionPredicate = (transaction) => {
    const partnerName = getPartnerName(transaction);
    const { partnerOriginator } = transaction;
    return Boolean(partnerName && partnerOriginator && partnerOriginator !== partnerName);
};
